import * as React from 'react';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import Avatar from '@mui/material/Avatar';
import { red } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';
import QueryStatsIcon from '@mui/icons-material/QueryStats';


function ItemBoxDDS238_2_ZN({item, onClick}) {

  var handleClick = () => {
    if (onClick) onClick(item);
  }

  const {device_last_data} = item;

  const name = item.name ?? item.ident
    ?? item.dashboard_element_name ?? item.device_name
    ?? item.device_model ?? 'not set';
  console.log("ItemBoxDDS238_2_ZN name : ", name);

  var ld = item.last_tag_data;

  return (
    <Card variant="outlined" sx={{ height: "100%" }}>
      <CardHeader avatar={
        <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
          {name.substring(0, 1)}
        </Avatar>
      }
      action={
        <IconButton aria-label="settings" onClick={handleClick}>
          <QueryStatsIcon />
        </IconButton>
      }
      title={name}
      subheader={`Activity : ${item.last_activity} sec`}
    />
      <CardContent>
        <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
          Voltage : {device_last_data["VOLTAGE"]} V
        </Typography>
        <Typography sx={{fontSize: 14}} color="text.secondary">
          Active power : {device_last_data["ACTIVE_POWER"]} Wh
        </Typography>
        <Typography sx={{mb: 1.5}} color="text.secondary">
          {ld && (
              ld["BUILD_IN_HUMIDITY"]===-128
                ? `Humidity : Not available`
                : `Humidity : ${ld["BUILD_IN_HUMIDITY"]}%`
              )}
        </Typography>
        <Typography sx={{mb: 1.5}} color="text.secondary">
          {ld && (
              ld["BUILD_IN_LIGHT_LUX"]===-128
                ? `Light lux : Not available`
                : `Light lux : ${ld["BUILD_IN_LIGHT_LUX"]}lx`
            )}
        </Typography>
      </CardContent>
    </Card>
  )
}


export {
  ItemBoxDDS238_2_ZN
}
